module.exports = __webpack_public_path__ + "img/white-tick.ae42babb.svg";